import React from 'react';
import { motion } from 'framer-motion';
import '../style/EstacionLanzamiento.css';
import '../style/Cohete.css';

// Torre + plataforma de lanzamiento. Es un elemento normal de la página
// (position: absolute, NO fixed), anclado cerca del final de todo el
// documento. Por eso se queda "atrás" cuando se hace scroll: no participa
// de la animación, solo el cohete (components/Cohete.js) se mueve.
//
// El cohete en sí también vive acá, dibujado y quieto sobre la plataforma
// (grupo .ls-rocket-docked más abajo), como un elemento más de esta misma
// ilustración: aparece junto con la torre (mismo whileInView, mismo
// instante) y se queda estacionado ahí sin importar cuánto se scrollee por
// el resto del sitio. Recién cuando el scroll llega al final absoluto de
// la página (prop `launching` en true, ver useRocketScrollState.js) este
// cohete quieto se oculta y el cohete "fixed" de components/Cohete.js -ya
// posicionado exactamente en el mismo lugar- toma el control para volar
// hacia el header.
const EstacionLanzamiento = ({ launching }) => {
  return (
    <motion.div
      className="launch-station"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <svg viewBox="0 0 260 400" className="launch-station-svg" role="img" aria-label="Torre y plataforma de lanzamiento">
        <defs>
          <radialGradient id="ls-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="var(--accent-color)" stopOpacity="0.35" />
            <stop offset="100%" stopColor="var(--accent-color)" stopOpacity="0" />
          </radialGradient>
        </defs>

        <g className="ls-stars">
          <circle cx="30" cy="30" r="1.1" />
          <circle cx="70" cy="60" r="0.9" />
          <circle cx="150" cy="20" r="1.1" />
          <circle cx="180" cy="55" r="0.9" />
          <circle cx="40" cy="90" r="0.9" />
          <circle cx="120" cy="15" r="1" />
        </g>

        <ellipse cx="100" cy="330" rx="70" ry="45" fill="url(#ls-glow)" />
        <line x1="15" y1="345" x2="245" y2="345" className="ls-ground" />

        <g className="ls-tower">
          <line x1="195" y1="60" x2="195" y2="345" />
          <line x1="225" y1="60" x2="225" y2="345" />
          <line x1="195" y1="90" x2="225" y2="120" />
          <line x1="225" y1="90" x2="195" y2="120" />
          <line x1="195" y1="150" x2="225" y2="180" />
          <line x1="225" y1="150" x2="195" y2="180" />
          <line x1="195" y1="210" x2="225" y2="240" />
          <line x1="225" y1="210" x2="195" y2="240" />
          <line x1="195" y1="270" x2="225" y2="300" />
          <line x1="225" y1="270" x2="195" y2="300" />
          <line x1="170" y1="180" x2="195" y2="180" />
        </g>
        <circle cx="195" cy="90" r="2.2" className="ls-light" />
        <circle cx="225" cy="240" r="2.2" className="ls-light ls-light-dim" />

        <rect x="65" y="290" width="70" height="10" rx="2" className="ls-pad" />
        <rect x="45" y="300" width="110" height="12" rx="2" className="ls-pad" />

        <g className="ls-vent">
          <line x1="70" y1="312" x2="60" y2="345" />
          <line x1="100" y1="312" x2="100" y2="345" />
          <line x1="130" y1="312" x2="140" y2="345" />
        </g>

        {/* Cohete quieto, posado sobre el pad (mismo dibujo que
            components/Cohete.js, con sus coordenadas Y desplazadas +80 para
            que la base -las patas, en y=210 en su propio viewBox- caiga
            justo en y=290, el borde superior del pad de abajo). Se oculta
            en el instante en que el cohete "fixed" toma el control. */}
        <g className="ls-rocket-docked" style={{ opacity: launching ? 0 : 1 }}>
          <path
            d="M100 90 C 86 115 80 145 80 170 L 120 170 C 120 145 114 115 100 90 Z"
            className="ls-rocket-body"
          />
          <rect x="80" y="170" width="40" height="110" className="ls-rocket-body" />
          <circle cx="100" cy="205" r="9" className="ls-window" />
          <line x1="80" y1="250" x2="120" y2="250" className="ls-rocket-line" />
          <line x1="80" y1="270" x2="120" y2="270" className="ls-rocket-line" />
          <path d="M80 258 L 60 290 L 80 290 Z" className="ls-rocket-body" />
          <path d="M120 258 L 140 290 L 120 290 Z" className="ls-rocket-body" />
        </g>
      </svg>
    </motion.div>
  );
};

export default EstacionLanzamiento;